import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const CustomerContactResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "49af8aea-8f8a-4d60-8077-7fa1eea107e8";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="identityid" caption='IdentityID' ></Column>
                <Column dataField="name" caption="Name"></Column>
                <Column dataField="cellPhone_1" caption="Cell Phone 1"></Column>
                <Column dataField="addressKeySequence" visible={false} caption="AddressKeySequence"></Column>
                <Column dataField="addressRowID" visible={false} caption="AddressRowID"></Column>
                <Column dataField="addressName" visible={false} caption="Address Name"></Column>
                <Column dataField="address_1" visible={false} caption="Address- 1"></Column>
                <Column dataField="address_2" visible={false} caption="Address- 2"></Column>
                <Column dataField="city" visible={false} caption="City"></Column>
                <Column dataField="state" visible={false} caption="State"></Column>
                <Column dataField="zip" visible={false} caption="Zip"></Column>
                <Column dataField="country" visible={false} caption="Country"></Column>
                <Column dataField="telephone_1" visible={false} caption="Telephone 1"></Column>
                <Column dataField="telephone_2" visible={false} caption="Telephone 2"></Column>
                <Column dataField="fax_1" visible={false} caption="Fax 1"></Column>
                <Column dataField="fax_2" visible={false} caption="Fax 2"></Column>
                <Column dataField="modem_1" visible={false} caption="Modem 1"></Column>
                <Column dataField="modem_2" visible={false} caption="Modem 2"></Column>
                <Column dataField="cellPhone_2" visible={false} caption="Cell Phone 2"></Column>
                <Column dataField="pager_1" visible={false} caption="Pager 1"></Column>
                <Column dataField="pager_2" visible={false} caption="Pager 2"></Column>
                <Column dataField="eMailAddress_1" visible={false} caption="EMailAddress- 1"></Column>
                <Column dataField="eMailAddress_2" visible={false} caption="EMailAddress- 2"></Column>
                <Column dataField="webSiteAddress_1" visible={false} caption="WebSiteAddress- 1"></Column>
                <Column dataField="webSiteAddress_2" visible={false} caption="WebSiteAddress- 2"></Column>
                <Column dataField="contactName" visible={false} caption="Contact Name"></Column>
                <Column dataField="idGroup" visible={false} caption="IDGroup"></Column>
                <Column dataField="idSubGroup" visible={false} caption="IDSubGroup"></Column>
                <Column dataField="reference1" visible={false} caption="Reference 1"></Column>
                <Column dataField="reference2" visible={false} caption="Reference 2"></Column>
                <Column dataField="webUserName" visible={false} caption='WebUserName' />
                <Column dataField="contactsUDC_1" visible={false} caption='ContactsUDC_1' />
                <Column dataField="contactsUDC_2" visible={false} caption='ContactsUDC_2' />
                <Column dataField="contactsUDC_3" visible={false} caption='ContactsUDC_3' />
                <Column dataField="contactsUDC_4" visible={false} caption='ContactsUDC_4' />
                <Column dataField="contactsUDC_5" visible={false} caption='ContactsUDC_5' />
                <Column dataField="contactsUDC_6" visible={false} caption='ContactsUDC_6' />
                <Column dataField="contactsUDC_7" visible={false} caption='ContactsUDC_7' />
                <Column dataField="contactsUDC_8" visible={false} caption='ContactsUDC_8' />
                <Column dataField="contactsUDC_9" visible={false} caption='ContactsUDC_9' />
                <Column dataField="contactsUDC_10" visible={false} caption='ContactsUDC_10' />
                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerContactResult);